import { createSelector } from '@ngrx/store';
import { selectApoState } from '../reducers';

export const selectApo = createSelector(
  selectApoState,
  (state) => state.input_params,
);